// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
import { packageMetadata } from './package-metadata';
import { getDefaultSlots, validatePackage } from '@progress/kendo-vue-common';
/**
 * @hidden
 */
var FormElementVue2 = {
  name: 'KendoFormElement',
  props: {
    horizontal: Boolean
  },
  created: function created() {
    validatePackage(packageMetadata);
  },
  inject: {
    kendoForm: {
      default: null
    }
  },
  computed: {
    formElementClassName: function formElementClassName() {
      return {
        'k-form': true,
        'k-form-horizontal': this.$props.horizontal === true
      };
    }
  },
  methods: {
    handleSubmit: function handleSubmit(e) {
      if (this.kendoForm) {
        this.kendoForm.onSubmit(e);
      }
    }
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  render: function render(createElement) {
    var h = gh || createElement;
    var defaultSlots = getDefaultSlots(this);
    return h("form", {
      "class": this.formElementClassName,
      onSubmit: this.handleSubmit,
      on: this.v3 ? undefined : {
        "submit": this.handleSubmit
      }
    }, [defaultSlots]);
  }
};
/**
 * @hidden
 */
var FormElement = FormElementVue2;
export { FormElement, FormElementVue2 };